import API from "../../config/api";

export const getInvoiceById = (payload: any, handleNext?: any) => async (dispatch: any) => {
    const path = "api/Invoice/GetById";
    await API().get(path, {
        params: payload,
    }).then((response: any) => {
        if (response.status === 200 && handleNext) {
            handleNext(response.data);
        }
    }).catch((err) => {
        handleNext(err);
    });
};

export const getInvoiceList = (payload: any, handleNext?: any) => async (dispatch: any) => {
    const path = "api/Invoice/GetInvoiceList";
    await API().get(path, {
        params: payload,
    }).then((response: any) => {
        if (response.status === 200 && handleNext) {
            handleNext(response.data);
        }
    }).catch((err) => {
        handleNext(err);
    });
};
export const UpdateInvoiceById = (defaultparams: any, callBack?: any) => async (dispatch: any) => {
    var path = "api/Invoice/UpdateInvoice";
    await API().patch(path, defaultparams).then((response: any) => {
        if (response.status === 200 && callBack) {
            callBack(response.data);
        }
    }).catch((err) => {
        callBack(err);
    });
}

export const getExportList = (payload: any, handleNext?: any) => async (dispatch: any) => {
    const path = "api/Invoice/GetExportList";
    await API().get(path, {
        params: payload,
    }).then((response: any) => {
        if (response.status === 200 && handleNext) {
            handleNext(response.data);
        }
    }).catch((err) => {
        handleNext(err);
    });
};

